import React from 'react';
import { Box, Typography } from '@mui/material';
import { VaultItemDTO } from '../../types';
import { createSubtleIceSurface, hashStringToSeed } from '../../theme/surfaces';
import { VaultItemActionMenu } from './VaultItemActionMenu';

interface MagicItemCardProps {
  item: VaultItemDTO;
  memberNameById: Map<string, string>;
  onDiscard: (instanceId: string) => void;
  onSell?: (instanceId: string) => void;
}

export const MagicItemCard: React.FC<MagicItemCardProps> = React.memo(function MagicItemCard({
  item,
  memberNameById,
  onDiscard,
  onSell,
}) {
  const surfaceSx = React.useMemo(
    () => ({ ...createSubtleIceSurface(hashStringToSeed(item.id), { rainbowSheen: true }), maxWidth: '400px' }),
    [item.id],
  );

  return (
    <Box sx={{ height: '100%', ...surfaceSx }} p={1.5}>
      <Box sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="subtitle2">{item.name}</Typography>
          {item.description && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              {item.description}
            </Typography>
          )}
          {item.salePrice > 0 && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              Sale: {item.salePrice}gc
            </Typography>
          )}
          {item.warbandMemberId && memberNameById.get(item.warbandMemberId) && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, fontStyle: 'italic' }}>
              Used by: {memberNameById.get(item.warbandMemberId)}
            </Typography>
          )}
        </Box>
        <VaultItemActionMenu
          itemName={item.name}
          instanceId={item.instanceId!}
          salePrice={item.salePrice}
          onDiscard={onDiscard}
          onSell={onSell}
        />
      </Box>
    </Box>
  );
});
